export enum EditionFieldDisplayType {
  Boolean = 1,
  Text,
  KeySellingPoint,
}

export class ChangedField {
  fieldName: string;
  displayType: EditionFieldDisplayType;
  oldValue: any;
  newValue: any;
  changeType: any;

  constructor(
    fieldName: string,
    displayType: EditionFieldDisplayType,
    oldValue: string,
    newValue: string,
    changeType: string,
  ) {
    this.fieldName = fieldName;
    this.displayType = displayType;
    this.oldValue = oldValue;
    this.newValue = newValue;
    this.changeType = changeType;
  }
}

export class EditionDiffModel {
  appId: string;
  editionId: string;
  editionName: string;
  wholesalePrice: number;
  suggestedRetailPrice: number;
  topLevelDataChanges: ChangedField[] = [];

  hasChanges(): boolean {
    return !!this.topLevelDataChanges.length;
  }
}
